import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import type { Contract } from "@/pages/human-resources/time-management/business/contract/Contract.ts";

export interface ScheduleDailyTag {
  id?: string;
  tag: DailyTag;
  shiftNumber?: number;
  overriddenMinutes?: number;
}

export function computeTagWorkDurationMinutes(
  sdt: ScheduleDailyTag,
  contract: Contract | undefined,
): number {
  if (sdt.overriddenMinutes !== undefined) {
    return sdt.overriddenMinutes;
  }
  return contract === undefined ? 0 : (
      sdt.tag.computeWorkDurationMinutes(contract)
    );
}
